module.exports = __webpack_public_path__ + "static/media/lora-wordmark-white.155e20c6.svg";